export default function Header({ text }) {
  return (
    <div className="mt-3  dark:bg-[#222222] dark:text-white">
      <div className="container mx-auto">
        <span className="text-4xl font-bold mt-3">{text}</span>
      </div>
    </div>
  );
}
